import styled from 'styled-components'
import Div100vh from 'react-div-100vh'
import CustomTheme from 'theme'

export const Wrapper = styled(Div100vh)`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 1rem;

    .heading {
        margin-bottom: 0.5rem;
        margin-top: 1rem;
    }

    .body {
        max-width: 648px;
        text-align: center;

        ${CustomTheme.breakPoint.tablet} {
            margin-bottom: 2.5rem;
        }
    }
`

export const BackButtonWrapper = styled.div`
    margin-bottom: auto;
    margin-top: -0.5rem;
    margin-left: -0.5rem;
    width: 100%;
`
